// extracted by mini-css-extract-plugin
module.exports = {"item":"M_df","item__image":"M_dg"};